import { Component } from '@angular/core';

@Component({
  selector: 'app-branding',
  standalone: true,
  template: `
    <div class="flex items-center justify-start pt-4 pl-4">
        <img
          src="./assets/images/logos/bonnapp-logo-horizontal.png"
          alt="logo"
          style="width: 100px; height: auto; margin-bottom: 10px; margin-left: 4px"
        />
    </div>
  `,
})
export class BrandingComponent {
  constructor() {}
}
